<script>
	import { Pie } from 'vue-chartjs'
	import deferred from 'chartjs-plugin-deferred'

	export default {
		extends: Pie,
		props: ['data'],
		data() {
			return {
				options: {
					animation: {
						animateRotate: true
					},
					cutoutPercentage: 40,
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'bottom',
						labels: {
							fontColor: '#000'
						}
					},
					plugins: {
            deferred: {
              yOffset: '75%',
              delay: 500
            }
          },
					tooltips: {
						callbacks: {
							label: function(tooltipItem, data) {
								return data.labels[tooltipItem.index]
							}
						}
					}
				}
			}
		},
		mounted() {
			this.addPlugin(deferred)
			this.renderChart(this.data, this.options)
		}
	}
</script>